import { counters } from './modules/counters';
import { checkboxCustom } from './modules/checkbox';
import { radioCustom } from './modules/radio';
import { faq } from './modules/faq';
import { reviews } from './modules/reviews';
import { reviewsSlider } from './modules/reviews_slider';
import { feedback } from './modules/feedback';
import { fixedHeader } from './modules/fixed_header';
import { citySelect } from './modules/city';
import { tabs } from './modules/tabs';
import { modals } from './modules/modals';
import { scrollTo } from './modules/scroll_to';
import { test } from './modules/test';
import { testBanner } from './modules/test_banner';
import { aboutSlider } from './modules/about_slider';
import { stepsSlider } from './modules/steps_slider';
import { burger } from './modules/burger';
// import { geoip } from './modules/geoip';
import { lazyload } from './modules/lazyload';
import { goals } from './modules/goals';
// import { beforeClose } from './modules/before_close';
import { documentsList } from './modules/documents_list';
import { tagSwiper } from './modules/tag_swiper';
import { Cookie } from './components/cookie';

document.addEventListener('DOMContentLoaded', function () {
    counters();
    checkboxCustom();
    radioCustom();
    faq();
    reviews();
    reviewsSlider();
    feedback();
    fixedHeader();
    citySelect();
    tabs();
    modals();
    scrollTo();
    test();
    testBanner();
    aboutSlider();
    stepsSlider();
    burger();
    // geoip();
    lazyload();
    goals();
    // beforeClose();
    documentsList();
    tagSwiper();

    let $selectDistricts = document.querySelector('.js-selectDistricts');
    if ($selectDistricts) {
        let cookie = new Cookie();

        $selectDistricts.addEventListener('change', function(e) {
            cookie.set('district', $selectDistricts.value);
        });
    }
});


